import {
  TablePseudoBottomBorderRow,
  TablePseudoBottomBorderRowProps,
} from "../TablePseudoBottomBorderRow"

export type TableHeaderGroupRowProps = TablePseudoBottomBorderRowProps

export function TableHeaderGroupRow({
  children,
  ...otherProps
}: TableHeaderGroupRowProps) {
  return (
    <TablePseudoBottomBorderRow {...otherProps}>
      {children}
    </TablePseudoBottomBorderRow>
  )
}
